import React from 'react';
import { styled } from '@xstyled/styled-components';
import { DescriptionFieldProps } from '../types';
import { FieldWrapper, Label } from '../sharedComponents';

const TextArea = styled.textarea`
  width: 100%;
  min-height: 120px;
  padding: 12px 16px;
  border: 1px solid #e1e5e9;
  border-radius: 8px;
  font-family: Raleway;
  font-size: 14px;
  background: #f8f9fa;
  resize: vertical;
  &:focus {
    outline: none;
    border-color: #9738ff;
    background: white;
  }
  &::placeholder {
    color: #999;
  }
  @media (max-height: 900px) {
    min-height: 110px;
    padding: 10px 14px;
    font-size: 13px;
  }
  @media (max-height: 780px) {
    min-height: 100px;
    padding: 8px 12px;
    font-size: 12.5px;
  }
`;

export const DescriptionField: React.FC<DescriptionFieldProps> = ({
  value,
  onChange,
  maxLength = 1200,
  placeholder = 'Enter description',
  disabled = false,
  required = false
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    if (newValue.length <= maxLength) {
      onChange(newValue);
    }
  };

  return (
    <FieldWrapper>
      <Label htmlFor="card-description">Card Description</Label>
      <TextArea
        id="card-description"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        maxLength={maxLength}
        disabled={disabled}
        required={required}
        aria-label="Card Description"
      />
    </FieldWrapper>
  );
};
